import React, { ReactNode } from 'react';

interface EmptyStateProps {
  classPrefix: string;
  visual?: ReactNode;
  title: string;
  description: string;
  children?: ReactNode;
  actions?: ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  classPrefix,
  visual,
  title,
  description,
  children,
  actions,
}) => (
  <div className={`${classPrefix}-state`}>
    <div className={`${classPrefix}-content`}>
      {visual}
      <h2 className={`${classPrefix}-title`}>{title}</h2>
      <p className={`${classPrefix}-description`}>{description}</p>
      {children}
      {actions}
    </div>
  </div>
);

export default React.memo(EmptyState);
